module.exports = __webpack_public_path__ + "static/media/codeScan.9a71c529.png";